<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            d="M9.16668 3.25C8.35312 3.25 7.69446 3.90866 7.69446 4.72222V6.38889C7.69446 6.8031 7.35867 7.13889 6.94446 7.13889C6.53024 7.13889 6.19446 6.8031 6.19446 6.38889V4.72222C6.19446 3.08023 7.52469 1.75 9.16668 1.75H15.2778C16.9198 1.75 18.25 3.08023 18.25 4.72222V15.2778C18.25 16.9198 16.9198 18.25 15.2778 18.25H9.16668C7.52469 18.25 6.19446 16.9198 6.19446 15.2778V13.6111C6.19446 13.1969 6.53024 12.8611 6.94446 12.8611C7.35867 12.8611 7.69446 13.1969 7.69446 13.6111V15.2778C7.69446 16.0913 8.35312 16.75 9.16668 16.75H15.2778C16.0914 16.75 16.75 16.0913 16.75 15.2778V4.72222C16.75 3.90866 16.0914 3.25 15.2778 3.25H9.16668Z"
            fill="currentColor"
        />
        <path
            d="M4.41926 6.41413C4.71215 6.70702 4.71215 7.18189 4.41926 7.47479L2.64405 9.25H10.2778C10.692 9.25 11.0278 9.58579 11.0278 10C11.0278 10.4142 10.692 10.75 10.2778 10.75H2.64402L4.41926 12.5252C4.71215 12.8181 4.71215 13.293 4.41926 13.5859C4.12637 13.8788 3.65149 13.8788 3.3586 13.5859L0.303044 10.5303C0.229418 10.4567 0.174299 10.3716 0.137689 10.2807C0.10266 10.194 0.083374 10.0993 0.083374 10C0.083374 9.89588 0.10459 9.79672 0.142936 9.7066C0.17518 9.63065 0.220515 9.55895 0.278942 9.49491C0.287643 9.48537 0.296588 9.47605 0.305766 9.46696L3.3586 6.41413C3.65149 6.12123 4.12637 6.12123 4.41926 6.41413Z"
            fill="currentColor"
        />
    </svg>
</template>
